const messages: any = {
    1: 'Usuario no tiene permisos para inicio de sesión (país inválido)',
    1001: 'Credenciales inválidas'
}

export const mapApiCodeMessage = (code: number) => {
    return messages[code] || 'Error interno, validar con administrador';
}